import { createContext, useContext, useState, useCallback } from "react";

const Ctx = createContext({ open: false, openModal: () => {}, closeModal: () => {} });

export function DemoModalProvider({ children }) {
    const [open, setOpen] = useState(false);
    const openModal = useCallback(() => setOpen(true), []);
    const closeModal = useCallback(() => setOpen(false), []);
    return <Ctx.Provider value={{ open, openModal, closeModal }}>{children}</Ctx.Provider>;
}

export function useDemoModal() {
    return useContext(Ctx);
}
